import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { Svg } from "../svg/Svg";
export const ArrowLeftIcon = forwardRef((props, ref) => (_jsx(Svg, { "data-testid": "ArrowLeftIcon", ...props, ref: ref, children: _jsx("g", { children: _jsx("polyline", { fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeWidth: props.strokeWidth, points: "9 4 5 8 9 12" }) }) })));
ArrowLeftIcon.displayName = "ArrowLeftIcon";
